export default {
  nav: {
    home: "Trang chủ",
    about: "Giới thiệu",
    services: "Menu & Dịch vụ",
    contact: "Liên hệ",
  },
  language: {
    vietnamese: "Tiếng Việt",
    english: "English",
  },
  common: {
    readMore: "Xem thêm",
    bookNow: "Đặt lịch ngay",
    viewDetails: "Xem chi tiết",
    contactUs: "Liên hệ với chúng tôi",
    comingSoon: "Sắp ra mắt",
    loading: "Đang tải...",
  },
  // Add translations for About section
  about: {
    title: "ĐÔI NÉT VỀ NGÓI SPA",
    description:
      "Ngói Spa được thành lập với sứ mệnh mang đến không gian thư giãn tâm hồn với cảm giác thư thái, nơi bạn có thể tạm gác lại những bận tâm và tìm thấy sự cân bằng hoàn hảo trong cuộc sống hiện đại. ",
    services:
      "Tọa lạc tại quận Tân Bình, Ngói Spa là điểm đến lý tưởng để bạn tận hưởng những phút giây thư thái với các dịch vụ chăm sóc toàn diện như spa thư giãn, facial chăm sóc da mặt, và nail nghệ thuật. Mỗi dịch vụ tại Ngói Spa được thực hiện bởi đội ngũ chuyên viên tận tâm, kỹ thuật vững vàng và luôn lắng nghe nhu cầu của bạn.",
    spa: "Chúng tôi sử dụng các liệu pháp spa nhẹ nhàng kết hợp với sản phẩm chất lượng cao, an toàn và dịu nhẹ cho làn da. Dù bạn cần cấp ẩm, làm dịu da nhạy cảm hay thư giãn bằng massage, Ngói Spa đều có giải pháp dành riêng cho bạn – trong một không gian yên tĩnh, dịu dàng và đầy cảm hứng chữa lành.",
    nail: "Đừng quên chiều chuộng đôi tay và bàn chân của bạn với các dịch vụ làm nail tại Ngói Spa. Từ những thiết kế đơn giản, thanh lịch đến các mẫu nail nghệ thuật sáng tạo, chúng tôi mang đến vẻ đẹp chỉn chu và đầy cá tính cho từng bộ móng.",
    contact:
      "Mở cửa từ 9:30 sáng đến 8:00 tối mỗi ngày, Ngói Spa chào đón bạn với sự nhẹ nhàng, ấm áp và dịch vụ tận tâm. Ngói Spa – Không gian thư giãn giữa lòng thành phố 🌿",
    features: {
      professional: {
        title: "Không Gian Ấm Cúng",
        description:
          "Thiết kế nội thất mộc mạc, ấm áp với ánh sáng dịu nhẹ và âm nhạc thư giãn. Môi trường sạch sẽ, an toàn và riêng tư cho từng khách hàng.",
      },
      relaxing: {
        title: "Kỹ Thuật Viên Tận Tâm",
        description:
          "Đội ngũ KTV được đào tạo chuyên môn bài bản, có chứng chỉ hành nghề và luôn cập nhật kỹ thuật mới. Phục vụ khách hàng với tinh thần trách nhiệm cao.",
      },
      diverse: {
        title: "Dịch Vụ Đa Dạng",
        description:
          "Từ massage thư giãn, chăm sóc da, nail art đến trị liệu thảo dược. Mỗi dịch vụ được thiết kế để mang lại cảm giác thư thái và làm đẹp tự nhiên.",
      },
      attentive: {
        title: "Tư Vấn Tận Tình",
        description:
          "Lắng nghe và hiểu rõ nhu cầu của từng khách hàng. Tư vấn phương pháp chăm sóc phù hợp, theo dõi hiệu quả và hỗ trợ chăm sóc tại nhà.",
      },
    },
  },
  // Add translations for Services section
  services: {
    title: "DỊCH VỤ CỦA CHÚNG TÔI",
    description:
      "Khám phá các dịch vụ làm đẹp và thư giãn cao cấp của chúng tôi",
    note: "Dưới đây là menu tham khảo tại Ngói, chúng tôi thường sẽ có những thay đổi nhỏ để làm mới dịch vụ hàng tháng cũng như áp dụng giảm giá 10-30%.",
    viewAll: "Xem tất cả dịch vụ",
    massage: {
      title: "MASSAGE THƯ GIÃN",
      price: "Giá từ 180.000 VNĐ",
      description:
        "Thư giãn hoàn toàn với các liệu pháp massage chuyên nghiệp, sử dụng tinh dầu thiên nhiên và kỹ thuật massage truyền thống để giảm căng thẳng, cải thiện tuần hoàn máu và mang lại cảm giác thư thái.",
    },
    facial: {
      title: "FACIAL - CHĂM SÓC DA MẶT",
      price: "Giá từ 180.000 VNĐ",
      description:
        "Dịch vụ chăm sóc da mặt chuyên sâu với công nghệ hiện đại và sản phẩm cao cấp. Từ làm sạch cơ bản đến điều trị chuyên sâu, chúng tôi mang đến làn da khỏe mạnh và rạng rỡ tự nhiên.",
    },
    hairWash: {
      title: "GỘI ĐẦU DƯỠNG SINH",
      price: "Giá từ 180.000 VNĐ",
      description:
        "Liệu pháp gội đầu thư giãn với thảo dược thiên nhiên, kết hợp massage da đầu chuyên nghiệp. Giúp thư giãn tinh thần, kích thích tuần hoàn máu và nuôi dưỡng tóc từ gốc đến ngọn.",
    },
    nails: {
      title: "NAIL ART & MANICURE",
      price: "Giá từ 180.000 VNĐ",
      description:
        "Dịch vụ làm nail chuyên nghiệp với đội ngũ thợ có tay nghề cao. Từ chăm sóc cơ bản đến nail art sáng tạo, chúng tôi mang đến bộ móng hoàn hảo theo phong cách riêng của bạn.",
    },
    eyelashes: {
      title: "MI MẮT & EYELASH EXTENSIONS",
      price: "Giá từ 180.000 VNĐ",
      description:
        "Dịch vụ nối mi chuyên nghiệp với chất liệu cao cấp, an toàn. Từ mi tự nhiên đến mi dramatic, tạo nên đôi mắt quyến rũ và cuốn hút theo đúng phong cách mà bạn mong muốn.",
    },
    waxing: {
      title: "WAXING - TẨY LÔNG",
      price: "Giá từ 180.000 VNĐ",
      description:
        "Dịch vụ tẩy lông chuyên nghiệp với sáp wax cao cấp, an toàn cho mọi loại da. Quy trình vệ sinh nghiêm ngặt, mang lại làn da mịn màng và kết quả bền lâu.",
    },
    bodyScrub: {
      title: "BODY SCRUB - TẨY TẾ BÀO CHẾT",
      price: "Giá từ 180.000 VNĐ",
      description:
        "Liệu pháp tẩy tế bào chết toàn thân với các thành phần tự nhiên, giúp làn da mịn màng, sáng khỏe. Kết hợp với các loại mặt nạ dưỡng ẩm để mang lại làn da mềm mại.",
    },
  },
  servicesSection: {
    title: "Dịch Vụ Chăm Sóc",
    description:
      "Ngói Spa luôn đặt sự hài lòng của khách hàng lên hàng đầu với đội ngũ chuyên viên giàu kinh nghiệm, sản phẩm chất lượng cao và không gian thư giãn tuyệt đối. Chúng tôi cam kết mang đến cho bạn những trải nghiệm dịch vụ tuyệt vời nhất.",
    videosTitle: "Khám Phá Dịch Vụ Qua Video",
    viewAllServices: "Xem Tất Cả Dịch Vụ",
  },
  // Add translations for Gallery section
  gallery: {
    title: "KHÔNG GIAN CỦA CHÚNG TÔI",
    description:
      "Hãy chiêm ngưỡng không gian spa đẹp và thư giãn của chúng tôi",
    images: {
      image1: {
        title: "Thiên nhiên trong spa",
        description: "Cây xanh tạo không gian thư giãn tự nhiên",
      },
      image2: {
        title: "Khu vực tiền sảnh",
        description: "Không gian tươi mát đem đến cảm giác thư thái, an yên",
      },
      image3: {
        title: "Phòng massage thư giãn",
        description: "Sạch sẽ, yên tĩnh và riêng tư",
      },
      image4: {
        title: "Phòng tắm tiện lợi",
        description: "Thiết kế hiện đại và sang trọng",
      },
      image5: {
        title: "Hoa thơm",
        description: "Chi tiết nhỏ tạo nên sự khác biệt",
      },
      image6: {
        title: "Tinh dầu thiên nhiên",
        description: "Sản phẩm chăm sóc cao cấp",
      },
      image7: {
        title: "Sảnh chính",
        description: "Nơi bắt đầu hành trình thư giãn",
      },
    },
  },
  // Add translations for Video section
  video: {
    title: "TRẢI NGHIỆM NGÓI SPA",
    description: "Xem video để trải nghiệm Ngói Spa",
  },
  // Add translations for Contact section
  contact: {
    title: "Thông tin liên hệ",
    findUs: "TÌM CHÚNG TÔI TRÊN BẢN ĐỒ",
  },
  // Add translations for Review section
  reviews: {
    subtitle: "Khách hàng nói gì",
    title: "Những chia sẻ chân thật",
    description:
      "Cảm nhận của khách hàng là động lực lớn nhất để chúng tôi không ngừng hoàn thiện và nâng cao chất lượng dịch vụ",
    items: {
      review1: {
        text: "Mình là khách hàng thân thuộc ở đây. Đến một lần là phải quay lại hoài vì tay nghề kĩ thuật viên và chị founder cực kì dễ thương và dồi dào kinh nghiệm. Hãy tin tôi. Ghé thử một lần, phải ghé suốt đời!",
        name: "Công Thoại",
        title: "Việt Nam",
      },
      review2: {
        text:
          "They are so friendly and helpful ❤️\n" +
          "If I had the chance I would give ten stars ✨✨✨✨\n" +
          "Also so clear and comfy place 🤗\n" +
          "I will come here again here s the best place for skin, hair, nail, massage and for more",
        name: "Ceyda",
        title: "Taiwan",
      },
      review3: {
        text: "I have visited 80+ countries and I can tell that the massage here is amazing. Whenever coming to Vietnam, I always take a taxi from my hotel in District 1 to get a 90-minute massage here.",
        name: "Mitt",
        title: "America",
      },
    },
  },
  // Add translations for Footer section
  footer: {
    tagline: "Beauty & Wellness",
    description:
      "Không gian thư giãn tâm hồn đẳng cấp, nơi bạn tìm thấy sự cân bằng hoàn hảo giữa vẻ đẹp tự nhiên và nghệ thuật chăm sóc sức khỏe.",
    address: "Địa chỉ",
    contact: "Liên hệ",
    phone: "Điện thoại",
    email: "Email",
    openingHours: "Giờ mở cửa",
    everyday: "Thứ 2 - Chủ nhật",
    appointmentNote: "Đặt lịch trước để được phục vụ tốt nhất",
    privacyLink: "Chính sách bảo mật",
    services: "Dịch vụ chính",
    servicesItems: {
      massage: "Massage Thư giãn",
      facial: "Chăm Sóc Da mặt",
      nail: "Nail Art & Nối Mi",
      herbal: "Gội Đầu Dưỡng Sinh",
      waxing: "Waxing",
      bodyScrub: "Tẩy Tế Bào Chết",
    },
    followUs: "Theo dõi chúng tôi",
    copyright: "© 2026 Ngói Spa. Tất cả quyền được bảo lưu.",
  },
  privacy: {
    title: "Chính Sách Bảo Mật",
    lastUpdated: "Cập nhật lần cuối",
    sections: {
      collect: {
        title: "Thu thập thông tin",
        desc: "Chúng tôi thu thập thông tin để cung cấp dịch vụ tốt hơn cho bạn, bao gồm:",
        item1: "Thông tin cá nhân: Họ tên, số điện thoại khi đặt lịch.",
        item2: "Lịch sử dịch vụ: Các gói liệu trình bạn đã sử dụng.",
        item3: "Phản hồi: Các đánh giá và ý kiến đóng góp của khách hàng.",
      },
      usage: {
        title: "Sử dụng thông tin",
        desc: "Thông tin của bạn được sử dụng cho các mục đích:",
        item1: "Xác nhận và nhắc nhở lịch hẹn.",
        item2: "Gửi thông báo về các chương trình khuyến mãi ưu đãi.",
        item3: "Cải thiện chất lượng dịch vụ chăm sóc khách hàng.",
      },
      security: {
        title: "Bảo mật dữ liệu",
        desc: "Ngói Spa cam kết bảo mật tuyệt đối thông tin khách hàng. Chúng tôi không chia sẻ, bán hoặc cho thuê thông tin cá nhân của bạn cho bất kỳ bên thứ ba nào vì mục đích thương mại.",
      },
      contact: {
        title: "Liên hệ",
        desc: "Nếu bạn có bất kỳ câu hỏi nào về chính sách này, vui lòng liên hệ với chúng tôi qua hotline hoặc email chính thức.",
      },
    },
  },
};
